module.exports = __webpack_public_path__ + "static/media/Aman_Sayyad.a4f9f2c5.jpg";